module.exports = __webpack_public_path__ + "static/media/dialpad-24px.348fe506.svg";